/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import thumbnailImg from 'assets/images/tumbnailImg.svg';
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import { Modal } from 'components/molecules/Modal';
import {
  useAddSpotlightVideos,
  useGetAllSpotlightVideos,
  useGetAllVideos,
  useRemoveSpotlightVideos,
} from 'framework/api/methods';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface SpotlightProps {
  [x: string]: any;
}

export const Spotlight: FC<SpotlightProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [selectedState, setSelectedState] = useState({
    label: 'Available',
    value: 'select',
  });

  const [searchText, setSearchText] = useState('');
  const [isOpenDeselectConfirmation, setIsOpenDeselectConfirmation] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState('');

  const [videoList, setVideoList] = useState([]);

  const { mutate: getAllVideosMutate, isLoading: getAllVideosIsLoading } = useGetAllVideos();
  const { mutate: getAllSpotlightVideosMutate, isLoading: getAllSpotlightVideosIsLoading } =
    useGetAllSpotlightVideos();

  const { mutate: addSpotlightVideosMutate, isLoading: addSpotlightVideosIsLoading } =
    useAddSpotlightVideos();
  const { mutate: removeSpotlightVideosMutate, isLoading: removeSpotlightVideosIsLoading } =
    useRemoveSpotlightVideos();

  const getAllVideos = () => {
    getAllVideosMutate(
      {
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.videos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const getAllSpotlightVideos = () => {
    getAllSpotlightVideosMutate(undefined, {
      onSuccess: ({ data: successData }: any) => {
        setVideoList(successData.spotlightVideos || []);
      },
      onError: ({ response: { data: errData }, response }: any) => {
        setVideoList([]);
        if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
          notify('Session expired.', 'error');
          setTimeout(() => {
            navigate('/auth/login');
            localStorage.clear();
          }, 2000);
        } else {
          notify(errData?.message || 'Something went wrong.', 'error');
        }
      },
    });
  };

  const addSpotlightVideos = (vid: string) => {
    addSpotlightVideosMutate(
      {
        vid,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'Status updated.', 'success');
          setIsOpenDeselectConfirmation(false);
          getAllVideos();
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };
  const removeSpotlightVideos = (vid: string) => {
    removeSpotlightVideosMutate(
      {
        vid,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'Status updated.', 'success');
          setIsOpenDeselectConfirmation(false);
          getAllSpotlightVideos();
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };
  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    getAllVideos();
  }, [debouncedSearchText]);

  const formatViews = (views: any) => {
    if (views >= 1_000_000) {
      return `${(views / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    }
    if (views >= 1_000) {
      return `${(views / 1_000).toFixed(1).replace(/\.0$/, '')}K`;
    }
    return views ?? 0;
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0 && secs > 0) {
      return `${mins.toString().padStart(2, '0')} min ${secs.toString().padStart(2, '0')} sec`;
    }
    if (mins > 0) {
      return `${mins.toString().padStart(2, '0')} min`;
    }
    return `${secs.toString().padStart(2, '0')} sec`;
  };

  return (
    <div className="flex flex-col w-full h-full py-6 px-8">
      <div className="flex justify-between items-center">
        <div className="w-1/3">
          <div className="w-[180px] bg-[#f7951e24]">
            <SimpleSelect
              isSearchable={false}
              value={selectedState}
              options={[
                {
                  label: 'Available',
                  value: 'select',
                },
                {
                  label: 'Selected',
                  value: 'selected',
                },
              ]}
              onChange={(e: any) => {
                setSelectedState(e);
                if (e.value === 'select') {
                  getAllVideos();
                } else {
                  getAllSpotlightVideos();
                }
              }}
            />
          </div>
        </div>

        {selectedState.value === 'select' && (
          <div className="w-2/3 md:flex justify-start items-start hidden">
            <Input
              icon="ri-search-line !text-[#7B1B67] font-semibold"
              value={searchText}
              placeholder="Search here..."
              className="!w-[400px]"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />
          </div>
        )}
      </div>

      <div className="text-sm font-semibold text-[#7B1B67] pt-3">
        Spotlight section allows to feature up to two videos on the video portal. Select two
        available videos.
      </div>

      <div className="h-full overflow-y-auto w-full mt-2">
        {(getAllVideosIsLoading ||
          getAllSpotlightVideosIsLoading ||
          addSpotlightVideosIsLoading ||
          removeSpotlightVideosIsLoading) && <Loader appearance="black" className="mt-5" />}

        {!(
          getAllVideosIsLoading ||
          getAllSpotlightVideosIsLoading ||
          addSpotlightVideosIsLoading ||
          removeSpotlightVideosIsLoading
        ) &&
          videoList?.length === 0 && (
            <div className="mt-5 text-sm text-center w-full text-neutral-500">No videos found.</div>
          )}
        {!(
          getAllVideosIsLoading ||
          getAllSpotlightVideosIsLoading ||
          addSpotlightVideosIsLoading ||
          removeSpotlightVideosIsLoading
        ) &&
          videoList?.map((video: any, index) => (
            <div className="p-3 flex bg-white rounded w-full h-fit mt-2" key={index}>
              <div className="flex md:h-[100px] h-fit gap-2 overflow-x-auto justify-between items-start w-full md:flex-row flex-col">
                <div className="flex md:w-1/3 w-full gap-x-2 h-full">
                  <img
                    src={video?.cover_image_url}
                    alt="img-video"
                    className="h-[100px] w-[180px] object-cover rounded"
                  />

                  <div className="flex flex-col h-full md:w-fit w-full justify-between items-start">
                    <div className="md:w-auto w-full text-sm font-medium text-[#63717A] md:max-w-[400px] max-w-full h-full max-h-[70px] overflow-y-auto">
                      {video?.title || ''}
                    </div>

                    <div className="flex gap-x-1">
                      <i className="ri-eye-fill text-[#7B1B67] text-[20px] leading-6" />
                      <div className="text-[14px] leading-6 text-[#63717A]">
                        {formatViews(video?.view_count) || 0}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={CN(
                    'bg-[#EFEFEF] flex flex-col p-3 gap-x-2 md:w-[calc(66%-160px)] w-full h-full rounded-md ',
                  )}
                >
                  <div className="flex w-full gap-x-3 flex-wrap gap-y-2">
                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Published</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-[145px] rounded text-[#63717A] !h-[24px]">
                        {video?.created_at
                          ? new Date(video.created_at)
                              .toLocaleString('en-US', {
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                                timeZone: 'UTC',
                              })
                              .replace(',', '')
                          : ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Category</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.category || ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs">Length</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {formatTime(video.length_seconds) || ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Monetize</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.monetization_status ? 'On' : 'Off'}
                      </div>
                    </div>

                    {/* <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[78px]">Uploaded By</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.uploaded_by || ''}
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="flex md:flex-col flex-row gap-3 font-thin h-full justify-start items-start ">
                  {selectedState.value === 'select' && (
                    <Button
                      bodyClassName="!justify-start !items-start"
                      className="!w-full !h-[38px] !bg-[#7B1B67]"
                      onClick={() => {
                        addSpotlightVideos(video.vid);
                      }}
                    >
                      <i className="ri-checkbox-circle-fill font-thin text-[16px] pr-1" />
                      Select
                    </Button>
                  )}

                  {selectedState.value === 'selected' && (
                    <Button
                      bodyClassName="!justify-start !items-start"
                      className="!w-full !h-[38px] !bg-[#7B1B67]"
                      onClick={() => {
                        setSelectedVideo(video.vid);
                        setIsOpenDeselectConfirmation(true);
                      }}
                    >
                      <i className="ri-close-circle-fill font-thin text-[16px] pr-1" />
                      Deselect
                    </Button>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>

      <Modal
        isActive={isOpenDeselectConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="Yes"
        secondaryButtonTitle="No"
        secondaryButtonProps={{
          className: '!w-[100px]',
        }}
        primaryButtonProps={{
          className: '!w-[100px] !mr-2',
          isLoading: removeSpotlightVideosIsLoading,
        }}
        onClickPrimaryBtn={() => {
          removeSpotlightVideos(selectedVideo);
        }}
        onClickSecondaryBtn={() => {
          setIsOpenDeselectConfirmation(false);
          setSelectedVideo('');
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#7B1B67]"
              onClick={() => {
                setIsOpenDeselectConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#7B1B67]" />
            <div className="pt-1 text-base text-[#737791] pb-3">
              Are you sure you want to deselect this video?
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Spotlight;
